module.exports = __webpack_public_path__ + "img/VP-Profi13_Overview.f9fd0637.jpg";